'use client';

import { CareType } from '@/directory/types';
import { createContext, ReactNode } from 'react';

export interface DirectoryTrackingProps {
  track?: (name: string, payload: any) => void;

  logClickEvent?: (clickEvent: any) => void;

  logPageViewLocationOverview?: (
    careType: CareType,
    locationName: string,
    currentUrl: string,
    geoType: string,
    geographicScale: string,
    statsResponse: any,
  ) => void;

  logPageViewLocationIndex?: (currentUrl: string) => void;

  children?: ReactNode;
}

export const DirectoryTrackingContext = createContext<DirectoryTrackingProps>(
  {},
);

export const DirectoryTrackingProvider = ({
  track,
  logClickEvent,
  logPageViewLocationOverview,
  logPageViewLocationIndex,
  children,
}: DirectoryTrackingProps) => {
  return (
    <DirectoryTrackingContext.Provider
      value={{
        track,
        logClickEvent,
        logPageViewLocationOverview,
        logPageViewLocationIndex,
      }}
    >
      {children}
    </DirectoryTrackingContext.Provider>
  );
};
